import { mixed, object, string } from 'yup';

import { TranslationType } from '../../../data/types/api/graphql';
import { messages, trim } from '../../../data/utils/form.utils';

export const schema = object()
  .shape({
    textNl: string().transform(trim).default(''),
    textEn: string().transform(trim).default(''),
    type: mixed<TranslationType>()
      .oneOf(Object.values(TranslationType))
      .required(messages.required.id),
    key: string().transform(trim).required(messages.required.id).default(''),
  })
  .required()
  .noUnknown();
